export default "__VITE_ASSET__4bc97b1b__"